// extracted by mini-css-extract-plugin
export default {"heading":"InvestmentDetails_heading__VnAEn","root":"InvestmentDetails_root__nzNSL","card":"InvestmentDetails_card__-qCnx"};